























import { Component, Vue } from 'vue-property-decorator';
import InviteMember from '@/components/common/InviteMember.vue';

@Component({
  components: {
    InviteMember,
  },
})
export default class ProjectInviteMenu extends Vue {
  private isOpenInvitationMenu: boolean = false;

  private closeInvitationModal(): void {
    this.isOpenInvitationMenu = false;
  }
}
